import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicy.vue')
  },
  {
    path: '/UserAgreement',
    name: 'UserAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserAgreement.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
